import { DatavizTheme } from "../.internal/themes/DatavizTheme";
export default DatavizTheme;